/* Salty Pepper v6 (Pepper Line): Pick-3 builder, food filter chips, preview-only cart notice. No dependencies. */
(function () {
  if (window.__spV6) return; window.__spV6 = true;
  var MIX = { 3: '3 Classics', 2: '2 Classics + 1 New', 1: '1 Classic + 2 New', 0: '3 New' };
  document.querySelectorAll('[data-sp-builder]').forEach(function (b) {
    var form = b.closest('form');
    var slots = b.querySelectorAll('[data-slot]');
    var sum = b.querySelector('[data-sum]');
    function update() {
      var classics = 0, names = [];
      slots.forEach(function (s) { var o = s.options[s.selectedIndex]; if (o.dataset.kind === 'classic') classics++; names.push(o.value.replace(/ Pepper$/, '')); });
      var title = MIX[classics];
      var radio = form && form.querySelector('#SpVariants input[data-title="' + title + '"]');
      if (radio && !radio.checked) { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); }
      if (sum) sum.innerHTML = '<b>' + title + '</b> · ' + (radio ? radio.dataset.price : '') + ' · shipping’s on us';
    }
    slots.forEach(function (s) { s.addEventListener('change', update); });
    update();
    /* re-announce the chosen mix once every script is bound, so price + button match it on first paint */
    function sync() { var r = form && form.querySelector('#SpVariants input:checked'); if (r) r.dispatchEvent(new Event('change', { bubbles: true })); }
    if (document.readyState === 'complete') setTimeout(sync, 0); else window.addEventListener('load', sync);
  });
  document.querySelectorAll('.sp-filter').forEach(function (bar) {
    var grid = bar.closest('.sp-container').querySelector('[data-sp-filter-grid]');
    bar.querySelectorAll('[data-sp-filter]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var tag = btn.dataset.spFilter;
        bar.querySelectorAll('[data-sp-filter]').forEach(function (x) { x.setAttribute('aria-pressed', x === btn ? 'true' : 'false'); });
        if (!grid) return;
        grid.querySelectorAll('[data-tags]').forEach(function (card) {
          var tags = (card.dataset.tags || '').split(',');
          card.hidden = !!tag && tags.indexOf(tag) === -1;
        });
      });
    });
  });
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-sp-stage]');
    if (!t) return;
    e.preventDefault();
    var n = document.createElement('div'); n.className = 'sp-toast'; n.setAttribute('role', 'status');
    n.textContent = 'Preview only: this pepper goes on sale at launch.';
    document.body.appendChild(n); setTimeout(function () { n.remove(); }, 2600);
  });
})();
